module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_23-1bf875afc5379aee8558364df60e532a.jpg";